import {post} from './axios'

export const server = {
    //------------------------------------  公共模块  --------------------------------------
    // 获取用户信息
    getUserInfo: function(paramObj){
        return post('/api/student/get_user_info',paramObj);
    },
    //获取系统消息
    getSystemMessage: function(paramObj){
        return post('/api/student/get_system_message',paramObj);
    },



    //------------------------------------  登录模块  --------------------------------------
    // 个人短信登录
    studentSmsLogin: function(paramObj){
        return post('/api/student/student_sms_login',paramObj);
    },
    //个人密码登录
    studentPwdLogin: function(paramObj){
        return post('/api/student/student_password_login',paramObj);
    },
    // 个人申请注册
    studentRegister: function(paramObj){
        return post('/api/student/student_register',paramObj);
    },
    // 发送验证码
    sendCode: function(paramObj){
        return post('/api/student/get_sms_code',paramObj);
    },
    // //个人注册第一步-验证个人注册验证码和密码是否正确
    studentRegisterFirst: function(paramObj){
        return post('/api/student/check_register_sms_code',paramObj);
    },
    //个人注册第二部 ---- 完善资料
    completeUserInfo: function(paramObj){
        return post('/api/student/complete_user_info',paramObj);
    },
    //企业申请注册
    companyRegister: function(paramObj){
        return post('/api/student/company_register',paramObj);
    },
    //企业密码登录
    companyPwdLogin: function(paramObj){
        return post('/api/student/company_password_login',paramObj);
    },
    //忘记密码接口
    forgetPassword: function(paramObj){
        return post('/api/student/forget_password',paramObj);
    },





    //------------------------------------  报名模块  --------------------------------------
    //获取可报名培训课程列表
    getCourseList: function(paramObj){
        return post('/api/student/get_course_list',paramObj);
    },
    //获取可报名培训课程列表(PC改版)
    getCourseNewList: function(paramObj){
        return post('/api/student/get_parent_course_list',paramObj);
    },
    //学员获取已报名课程列表
    studentGetSignList: function(paramObj){
        return post('/api/student/student_get_sign_list',paramObj);
    },
    //学员-取消报名接口
    studentCancelSign: function(paramObj){
        return post('/api/student/student_cancel_sign',paramObj);
    },
    //学员-申请取消报名接口
    applyCancelSign: function(paramObj){
        return post('/api/student/apply_cancel_sign',paramObj);
    },
    //申请调剂接口
    studentApplyChange: function(paramObj){
        return post('/api/student/student_apply_change',paramObj);
    },
    //学员查询成绩接口
    studentSearchResult: function(paramObj){
        return post('/api/student/student_search_result',paramObj);
    },
    //获取班期数据列表
    getPlanList: function(paramObj){
        return post('/api/student/get_plan_list',paramObj);
    },
    //获取班期数据列表（PC改版）
    getPlanNewList: function(paramObj){
        return post('/api/student/get_course_list_pc',paramObj);
    },
    //获取课程报名资料模块
    getSignDataList: function(paramObj){
        return post('/api/student/get_sign_data_list',paramObj);
    },
    //报名接口
    studentSign: function(paramObj){
        return post('/api/student/student_sign',paramObj);
    },
    //上传图片接口
    uploadPic: function(paramObj){
        return post('/api/student/upload_pic',paramObj);
    },
    //获取学员报名某一班期所提交的资料
    getStudentSignDetail: function(paramObj){
        return post('/api/student/get_student_sign_detail',paramObj);
    },
    //获取年审工种列表
    getYearType: function(paramObj){
        return post('/api/student/get_year_type',paramObj);
    },
    //移动端验证年龄限制
    checkIfAge: function(paramObj){
        return post('/api/student/check_age',paramObj);
    },
    //调起支付第一步
    applyPayFist: function(paramObj){
        return post('/api/student/apply_pay',paramObj);
    },
    //调起支付第二步
    applyPaySecond: function(paramObj){
        return post('/api/PayV36',paramObj);
    },
    // 微信支付
    wechartPay: function(paramObj){
        return post('/api/student/doJsPay',paramObj);
    },
    // 提交发票申请
    invoice_apply: function(paramObj){
        return post('/api/student/invoice_apply',paramObj);
    },
    // 发票查询
    getTicketDetail: function(paramObj){
        return post('/api/student/get_invoice',paramObj);
    },
    // 修改发票
    updateInvoice: function(paramObj){
        return post('/api/student/invoice_modify',paramObj);
    },
    // 获取课程表单配置
    getCourseConfig: function(paramObj){
        return post('/api/student/get_course_config',paramObj);
    },
    // 提交表单资料
    submitSignFrom: function(paramObj){
        return post('/api/student/submit_sign_from',paramObj);
    },




    //------------------------------------  企业模块  --------------------------------------
    //企业修改密码
    companyUpdatePwd: function(paramObj){
        return post('/api/student/company_modify_password',paramObj);
    },
    //企业-获取绑定的学员
    getBindStudent: function(paramObj){
        return post('/api/student/get_bind_student',paramObj);
    },
    //企业-确认同意绑定学员
    confirmBindStudent: function(paramObj){
        return post('/api/student/confirm_bind_student',paramObj);
    },
    //企业-确认解绑学员
    confirmUnbindStudent: function(paramObj){
        return post('/api/student/confirm_unbind_student',paramObj);
    },





    //------------------------------------  个人模块  --------------------------------------
    //个人-修改密码
    studentUpdatePwd: function(paramObj){
        return post('/api/student/student_modify_password',paramObj);
    },
    //个人-获取企业列表
    getCompanyList: function(paramObj){
        return post('/api/student/get_company_list',paramObj);
    },
    //个人-申请绑定企业
    applyBindCompany: function(paramObj){
        return post('/api/student/apply_bind_company',paramObj);
    },
    //个人-解绑企业
    confirmUnbindCompany: function(paramObj){
        return post('/api/student/confirm_unbind_company',paramObj);
    },
    //个人-解绑企业
    studentModifyPhone: function(paramObj){
        return post('/api/student/student_modify_phone',paramObj);
    },

}
